import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";

// material-ui
import { useTheme, Box } from "@mui/material";

// project imports
import LogoSection from "../LogoSection";
// import SearchSection from './SearchSection';
import NotificationSection from "./NotificationSection";
import ProfileMenu from "./ProfileMenu";
import MobileNavigation from "./MobileNavigation";
import UpgradeBadge from "components/Upgrade/UpgradeBadge";
import { useExperimentalMode } from "utils/experimentalMode";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const location = useLocation();
  const experimental = useExperimentalMode();

  // Function to check if a link is active
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  // Common link styles with active state
  const getLinkStyles = (isActive) => ({
    color: isActive ? theme.palette.text.secondary : theme.palette.text.primary,
    textDecoration: "none",
    // textDecoration: isActive ? "underline" : "none",
    fontSize: "0.875rem",
    fontWeight: isActive ? 700 : 500,
    padding: "8px 12px",
    borderRadius: "16px",
    backgroundColor: isActive
      ? theme.palette.mode === "dark"
        ? theme.palette.action.hover
        : "#f5f5f5"
      : "transparent",
    border: isActive ? `1px solid ${theme.palette.divider}` : "none",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.action.hover
          : "rgb(240, 240, 240)",
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Logo Section - Left Aligned */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "228px",
          [theme.breakpoints.down("md")]: {
            minWidth: "auto",
          },
        }}
      >
        <LogoSection />
      </Box>

      {/* Navigation Section - Center Aligned */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            alignItems: "center",
          }}
        >
          {!experimental && (
            <>
              <Link
                to="/dashboard"
                style={getLinkStyles(isActiveLink("/dashboard"))}
              >
                Dashboard
              </Link>
              <Link to="/clients" style={getLinkStyles(isActiveLink("/clients"))}>
                Clients
              </Link>
              <Link to="/engagements" style={getLinkStyles(isActiveLink("/engagements"))}>
                Engagements
              </Link>
              <Link to="/insights" style={getLinkStyles(isActiveLink("/insights"))}>
                Insights
              </Link>
            </>
          )}
        </Box>
      </Box>

      {/* Profile Section - Right Aligned */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          minWidth: "228px",
          [theme.breakpoints.down("md")]: {
            minWidth: "auto",
          },
        }}
      >
        {/* Mobile Navigation */}
        <MobileNavigation />

        {/* Desktop Profile Section */}
        <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 1 }}>
          {/* notification & profile */}
          {/* TODO */}
          <UpgradeBadge />
          <NotificationSection />
          <ProfileMenu />
        </Box>
      </Box>
    </Box>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
